import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  className,
}: SectionHeadingProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-3',
        align === 'center' && 'items-center text-center',
        align === 'left' && 'items-start text-left',
        className,
      )}
    >
      {eyebrow && (
        <span className="text-sm font-semibold uppercase tracking-wider text-brand-500">
          {eyebrow}
        </span>
      )}
      <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">{title}</h2>
      {description && (
        <p className="max-w-2xl text-lg text-gray-600">{description}</p>
      )}
    </div>
  );
}
